define('app/editor/dialogs/DomainReportDialogView',['require','./SaveDialogView','app/visualizations/FormatFactory','glu/dialog','hbs!./DomainReportDialogView.hbs'],function(require) {
	'use strict';

	var SaveDialogView = require('./SaveDialogView'),
		FormatFactory = require('app/visualizations/FormatFactory'),
		dialog = require('glu/dialog');

	var view = SaveDialogView.extend({

		dialogTitle: 'Details',

		getClass: function() {
			return 'modal-domain-report';
		},

		dialogButtons: [{
			text: 'Ok',
			callback: 'closeDialog',
			className: 'btn-primary'
		}],

		template: require('hbs!./DomainReportDialogView.hbs'),

		initialize: function() {
			var title = this.model.get('domain').get('name');

			if (title.substr(title.length - 1) === 's') {
				title = title.substring(0, title.length - 1);
			}

			this.columns = this.generateData();
			this.dialogTitle = title + ' details';
		},

		serializeData: function() {
			return this;
		},

		generateData: function() {
			var self = this,
				output = [],
				obj = {};

			if (this.model.results().rows[0]) {
				for (var i = 0; i < this.model.results().rows[0].length; i++) {
					var enumeration,
						domain = self.model.get('domain');

					if (domain.get('fieldCollection').get(self.model.results().header[i].fieldId) && domain.get('fieldCollection').get(self.model.results().header[i].fieldId).get('enumeration')) {
						enumeration = domain.get('fieldCollection').get(self.model.results().header[i].fieldId).get('enumeration');
					}
					var formatter = FormatFactory.formatterForType(self.model.results().header[i].type, {
						enumeration: enumeration
					});

					obj = {
						name: this.model.results().header[i].name,
						value: formatter(this.model.results().rows[0][i])
					};

					output.push(obj);
				}
			}

			return output;
		},

		closeDialog: function() {
			dialog.close();
		}
	});

	return view;
});

